import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Header } from "./Header";
import { getSession } from "../../../reducers/selectors";
import { signOut } from "./../../../actions/auth";

function mapStateToProps(state) {
  const userSession = getSession();
  const username = userSession ? userSession.Username : null;

  const isProdEnv = userSession ? userSession.IsProductionEnv : true;
  const isTestingUser = userSession && userSession.IsTestingUser ? userSession.IsTestingUser : false;

  return {
    quotes: [],
    username,
    isProdEnv,
    isTestingUser,
  };
}

function mapDispatchToProps(dispatch) {
  let actions = bindActionCreators(
    {
      signOut,
    },
    dispatch
  );

  return { actions, dispatch };
}

export default connect(mapStateToProps, mapDispatchToProps)(Header);
